import React from 'react';
import { useLocation } from 'react-router-dom';
import { Wrench } from 'lucide-react';

import { useAuthenticatedState } from 'src/authenticated-state/context';
import Responsive from 'src/components/responsive';
import { isUpcomingMaintenanceWindowNotification } from 'src/services/api/notifications';
import InlineBanner from 'src/components/inline-banner/InlineBanner';
import { usePersistentState } from 'src/services/storage/use-persistent-state';

export default function MaintenanceWindowAlert() {
    const { pathname } = useLocation();
    const { notifications: allNotifications } = useAuthenticatedState();
    const [isDismissed, setIsDismissed] = usePersistentState('maintenanceWindowAlertDismissed', false);

    if (
        pathname === '/landlord/inner/unmatched-listings' ||
        pathname.startsWith('/landlord/inner/messages/from-lead') ||
        pathname.startsWith('/landlord/inner/playbooks')
    ) {
        return null;
    }

    const relevantNotifications = allNotifications.filter(isUpcomingMaintenanceWindowNotification);

    if (relevantNotifications.length === 0 || isDismissed) { return null; }

    const notification = relevantNotifications[0];

    return (
        <Responsive desktop>
            <InlineBanner
                severity="info"
                icon={<Wrench size={15} />}
                title={notification.payload.maintenanceWindow.getAlertTitle()}
                description={notification.text}
                onDismiss={() => setIsDismissed(true)}
            />
        </Responsive>
    );
}
